import { render, staticRenderFns } from "./ApplicantPassportData.vue?vue&type=template&id=0253ca9c&"
import script from "./ApplicantPassportData.vue?vue&type=script&lang=js&"
export * from "./ApplicantPassportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports